import React, { Component } from 'react'
import cn from 'classnames'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import 'styles/app/apps/projected-sites-manager.scss'
import { IconButton } from '@material-ui/core'
import IconBack from '@material-ui/icons/ArrowBack'
import { List } from 'immutable'
import * as ROUTE from 'constants/appRouting'
import { SITE_TYPE_FRESHWATER, SITE_TYPE_SEAWATER } from 'constants/index'
import {
  clearActiveSite,
  clearActiveSiteRow,
  clearProjectedSitesManagerStore,
  fetchProjectedSitesManagerList,
  setActiveSite,
  setActiveSiteRow,
  setBaseProducts,
  setIsLoad,
  setProjectedProducts,
  setPsfs,
} from 'reducers/projectedSitesManager/reducer'
import Psfs from 'lib/psfs/Psfs'
import { ReactComponent as IconChangeView } from 'assets/img/change-view.svg'
import { StyledSnapshotLabel } from 'routes/App/Apps/ProjectedSitesManager/ProjectedSitesManager.styles'
import CircleLoader from 'components/Loading/CircleLoader'
import messages from './translate'
import ProjectedSitesManagerTable from './ProjectedSitesManagerTable'
import SeawaterSiteListForm from './SeawaterSiteListForm'
import SeawaterFilterBar from './SeawaterFilterBar'
import SingleItemTable from './SingleItemTable'
import SingleItemForm from './SingleItemForm'
import Diagram from './SingleItemForm/Diagram'
import FreshwaterFilterBar from './FreshwaterFilterBar'
import FreshwaterClientListForm from './FreshwaterClientListForm'
import SnapshotsManagerMenu from './SnapshotsManagerMenu'

class ProjectedSitesManagerLayout extends Component {
  constructor(props) {
    super(props)
    const {
      match: {
        params: {
          type: selectedSiteType,
          id: selectedSiteId,
          snapshot: selectedSnapshot,
          specie: selectedSpecieId,
          year: selectedYearClass,
        },
      },
    } = props

    this.state = {
      isPanelOpen: false,
      isEditMode: false,
      isSnapshotsManagerMenuOpened: false,
      selectedSnapshot,
      selectedClientSite: '',
      scrollHeight: 0,
      selectedSiteType,
      selectedSiteId,
      selectedSpecieId,
      selectedYearClass,
    }

    this.tableRef = React.createRef()
  }

  componentDidUpdate(prevProps) {
    const {
      match: {
        params: {
          type: oldType,
          id: oldId,
          snapshot: oldSnapshot,
          specie: oldSpecieId,
          year: oldYearClass,
        },
      },
    } = prevProps
    const {
      match: {
        params: {
          type: newType,
          id: newId,
          snapshot: newSnapshot,
          specie: newSpecieId,
          year: newYearClass,
        },
      },
    } = this.props

    if (
      oldType !== newType &&
      (newType === SITE_TYPE_SEAWATER || newType === SITE_TYPE_FRESHWATER)
    ) {
      this.setState({
        selectedSiteType: newType,
      })
    }

    if (oldId !== newId) {
      this.setState({
        selectedSiteId: newId,
      })
    }

    if (oldSnapshot !== newSnapshot) {
      this.setState({
        selectedSnapshot: newSnapshot,
      })
    }

    if (oldSpecieId !== newSpecieId) {
      this.setState({
        selectedSpecieId: newSpecieId,
      })
    }

    if (oldYearClass !== newYearClass) {
      this.setState({
        selectedYearClass: newYearClass,
      })
    }
  }

  componentWillUnmount() {
    const { clearProjectedSitesManagerStore } = this.props

    clearProjectedSitesManagerStore()
  }

  isMainTable = () => {
    const { selectedSnapshot } = this.state

    return selectedSnapshot === 'main-table'
  }

  isUserHasEditPermissions = () => {
    const { selectedSnapshot } = this.state
    const { projectedSitesManagerAdmin, snapshots } = this.props
    const snapshotsList = snapshots.toJS()
    const { currentUserIsSnapshotManager = false } =
      snapshotsList.find(({ id }) => id === +selectedSnapshot) || {}

    return (
      projectedSitesManagerAdmin ||
      this.isMainTable() ||
      currentUserIsSnapshotManager
    )
  }

  onEditData = activeSite => {
    if (!this.isUserHasEditPermissions()) return

    const { setActiveSite, clearActiveSite } = this.props

    if (!activeSite) {
      clearActiveSite()
    } else {
      setActiveSite(activeSite)
    }

    this.setState(prevState => {
      const result = { isEditMode: !!activeSite }

      if (!prevState.isPanelOpen) {
        result.isPanelOpen = true
      }

      return result
    })
  }

  handleSnapshotsManagerMenu = value => {
    this.setState({
      isSnapshotsManagerMenuOpened: value,
    })
  }

  onEditSingleItemData = activeSiteRow => {
    const {
      setActiveSiteRow,
      setBaseProducts,
      setProjectedProducts,
    } = this.props
    const { selectedSiteType } = this.state

    if (selectedSiteType === SITE_TYPE_FRESHWATER) {
      if (!activeSiteRow.subrow) {
        return
      }

      setActiveSiteRow({ ...activeSiteRow.actionData, ...activeSiteRow })
    } else {
      setActiveSiteRow(activeSiteRow)
    }

    setBaseProducts(List([]))
    setProjectedProducts(List([]))
    this.setState({
      isPanelOpen: true,
    })
  }

  onPanelClose = () => {
    const { clearActiveSite, clearActiveSiteRow } = this.props

    this.setState(
      {
        isPanelOpen: false,
        isEditMode: false,
      },
      () => {
        clearActiveSite()
        clearActiveSiteRow()
      },
    )
  }

  changeSiteTypeOrSnapshot = (event, value, snapshot) => {
    const { setPsfs, setIsLoad } = this.props
    const url = `${ROUTE.PROJECTED_SITES_MANAGER}/${value}/${snapshot}`
    const psfs = new Psfs(url)
    psfs.addPagination(1, 100)

    this.setState(
      {
        selectedSiteType: value,
        selectedSnapshot: snapshot,
      },
      () => {
        setPsfs(psfs)
        setIsLoad(true)
      },
    )
  }

  renderSiteTypeTabs = () => {
    const {
      intl: { formatMessage },
    } = this.props
    const { selectedSiteType, selectedSnapshot } = this.state

    return (
      <Tabs
        value={selectedSiteType}
        className="site-type-tabs"
        onChange={(event, value) => {
          if (value !== selectedSiteType) {
            this.changeSiteTypeOrSnapshot(event, value, selectedSnapshot)
          }
        }}>
        <Tab
          value={SITE_TYPE_SEAWATER}
          className="filter-tab"
          label={formatMessage(messages.seawater)}
        />
        <Tab
          value={SITE_TYPE_FRESHWATER}
          className="filter-tab"
          label={formatMessage(messages.freshwater)}
        />
      </Tabs>
    )
  }

  goBack = () => {
    const { history, storePsfs, fetchProjectedSitesManagerList } = this.props
    const { selectedSiteType, selectedSiteId, selectedSnapshot } = this.state

    this.setState({
      selectedClientSite: '',
      isPanelOpen: false,
    })

    if (selectedSiteId) {
      fetchProjectedSitesManagerList({
        psfs: storePsfs,
        siteType: selectedSiteType,
        snapshot: selectedSnapshot,
      })

      history.goBack()
    } else {
      history.push(ROUTE.APPS)
    }
  }

  getSnapshotName = () => {
    const { selectedSnapshot } = this.state
    const {
      intl: { formatMessage },
      snapshots,
    } = this.props
    const snapshotsList = snapshots.toJS()
    const { name } =
      snapshotsList.find(({ id }) => id === +selectedSnapshot) || {}

    return name || formatMessage(messages.mainTable)
  }

  setScrollHeight = () => {
    if (!this.tableRef || (this.tableRef && !this.tableRef.current)) {
      return
    }

    const height = this.tableRef.current.scrollTop

    this.setState({ scrollHeight: height })
  }

  scrollToCurrentProduct = () => {
    if (!this.tableRef || (this.tableRef && !this.tableRef.current)) {
      return
    }

    const { current: tableRef } = this.tableRef
    const { scrollHeight } = this.state

    tableRef.scroll({
      top: scrollHeight,
      behavior: 'auto',
    })
  }

  render() {
    const {
      isPanelOpen,
      isSnapshotsManagerMenuOpened,
      isEditMode,
      selectedSiteType,
      selectedSiteId,
      selectedSpecieId,
      selectedYearClass,
      selectedClientSite,
      selectedSnapshot,
    } = this.state
    const {
      intl: { formatMessage },
      currentApp: { name: appName },
      tableRows,
      isLoadTable,
    } = this.props
    const { data, count } = tableRows.toJS()
    const productsTableData = []

    data.forEach(({ products, ...rest }) => {
      productsTableData.push({ ...rest, subrow: false })

      if (Array.isArray(products)) {
        products.forEach(product => {
          productsTableData.push({
            ...product,
            id: product.predictionId,
            predictedSales: product.predictionBaseProductSales,
            subrow: true,
            actionData: rest,
          })
        })
      }
    })

    const isSeawater = selectedSiteType === SITE_TYPE_SEAWATER

    return (
      <div className="module logbook-module projected-sites-manager">
        <div className="header">
          <div className="header-section">
            <div className="title">
              <IconButton
                size="medium"
                className="btn-back"
                onClick={this.goBack}>
                <IconBack fontSize="small" />
              </IconButton>
              {appName + (selectedSiteId ? selectedClientSite : '')}
            </div>
            {!this.isMainTable() && (
              <StyledSnapshotLabel>
                {formatMessage(messages.snapshot)}
              </StyledSnapshotLabel>
            )}
            <CircleLoader loading={isLoadTable} />
            {!selectedSiteId && (
              <>
                <div
                  className="button snapshot-button"
                  onClick={() => {
                    this.handleSnapshotsManagerMenu(true)
                    this.onPanelClose()
                  }}>
                  <IconButton className="icon-btn">
                    <IconChangeView />
                  </IconButton>
                  <div className="text">{this.getSnapshotName()}</div>
                </div>
                {this.renderSiteTypeTabs()}
              </>
            )}
          </div>
          {!selectedSiteId && (
            <div className="header-section">
              {isSeawater ? (
                <SeawaterFilterBar
                  {...this.props}
                  onOpenForm={this.onEditData}
                  siteType={selectedSiteType}
                  selectedSnapshot={selectedSnapshot}
                />
              ) : (
                <FreshwaterFilterBar
                  {...this.props}
                  onOpenForm={this.onEditData}
                  siteType={selectedSiteType}
                  selectedSnapshot={selectedSnapshot}
                />
              )}
            </div>
          )}
        </div>
        {selectedSiteId ? (
          <div
            className={cn('module-content', {
              'side-panel-open': isPanelOpen,
              'diagram-open': !isPanelOpen && data.length && !isLoadTable,
            })}>
            <SingleItemTable
              {...this.props}
              tableRef={this.tableRef}
              tableData={{ data: productsTableData, count }}
              onEditData={this.onEditSingleItemData}
              onPanelClose={this.onPanelClose}
              setActiveItem={(client, site, specie, year) => {
                this.setState({
                  selectedClientSite: `
                    ${client ? ` / ${client}` : ''}
                    ${site ? ` / ${site}` : ''}
                    ${specie ? ` / ${specie}` : ''}
                    ${year ? ` / ${year}` : ''}
                  `,
                })
              }}
              siteType={selectedSiteType}
              siteId={selectedSiteId}
              snapshot={selectedSnapshot}
              specieId={selectedSpecieId}
              year={selectedYearClass}
            />
            <Diagram isFormOpened={!isPanelOpen} siteType={selectedSiteType} />
            <SingleItemForm
              isFormOpened={isPanelOpen}
              onPanelClose={this.onPanelClose}
              siteType={selectedSiteType}
              snapshot={selectedSnapshot}
              siteId={selectedSiteId}
              specieId={selectedSpecieId}
              year={selectedYearClass}
              setScrollHeight={this.setScrollHeight}
              scrollToCurrentProduct={this.scrollToCurrentProduct}
            />
          </div>
        ) : (
          <div
            className={cn('module-content', {
              'side-panel-open': isPanelOpen,
            })}>
            <ProjectedSitesManagerTable
              {...this.props}
              onEditData={this.onEditData}
              onPanelClose={this.onPanelClose}
              siteType={selectedSiteType}
              selectedSnapshot={selectedSnapshot}
            />
            {isSeawater ? (
              <SeawaterSiteListForm
                isFormOpened={isPanelOpen}
                isEditMode={isEditMode}
                onPanelClose={this.onPanelClose}
                siteType={selectedSiteType}
                selectedSnapshot={selectedSnapshot}
              />
            ) : (
              <FreshwaterClientListForm
                isFormOpened={isPanelOpen}
                onPanelClose={this.onPanelClose}
                siteType={selectedSiteType}
                selectedSnapshot={selectedSnapshot}
              />
            )}
          </div>
        )}
        <SnapshotsManagerMenu
          isModalOpened={isSnapshotsManagerMenuOpened}
          handleCloseModal={() => {
            this.handleSnapshotsManagerMenu(false)
          }}
          setSnapshot={this.changeSiteTypeOrSnapshot}
          selectedSiteType={selectedSiteType}
          selectedSnapshot={selectedSnapshot}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    projectedSitesManagerAdmin: state.getIn([
      'profile',
      'profile',
      'projectedSitesManagerAdmin',
    ]),
    storePsfs: state.getIn(['projectedSitesManager', 'storePsfs']),
    isLoadTable: state.getIn(['projectedSitesManager', 'isLoadTable']),
    tableRows: state.getIn(['projectedSitesManager', 'singleItemTableData']),
    snapshots: state.getIn(['projectedSitesManager', 'snapshots']),
  }),
  {
    setPsfs,
    setIsLoad,
    setActiveSite,
    setActiveSiteRow,
    clearActiveSite,
    clearActiveSiteRow,
    setBaseProducts,
    setProjectedProducts,
    clearProjectedSitesManagerStore,
    fetchProjectedSitesManagerList,
  },
)(injectIntl(withRouter(ProjectedSitesManagerLayout)))
